import React, {Component} from 'react'
import {Button, Collapse} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import ProjectBudgetList from "./ProjectBudgetList";
import ProjectBudgetInput from "./ProjectBudgetInput";

export default class ProjectBudget extends Component{

    state = {
        showInput: false
    }

    addBudget = () => {
        this.setState({showInput: !this.state.showInput})
    }

    render(){

        const {props, state} = this

        return(
            <div>
                <Button
                    size="sm"
                    color={state.showInput ? 'warning' : 'success'}
                    onClick={this.addBudget}
                >
                    <FontAwesomeIcon color="#fff" icon={state.showInput ? 'minus' : 'plus'}/>{' '}
                    {state.showInput ? 'Cancel' : 'Add Budget'}
                </Button>

                <Collapse isOpen={state.showInput}>
                    <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">
                        <ProjectBudgetInput
                            successMessage="Budget Added"
                            project_id={props.project_id}
                            addresses={props.addresses}
                            onSaved={() => this.setState({showInput: false})}
                            onCancel={() => this.setState({showInput: false})}
                            resetForm={true}
                        />
                    </div>
                </Collapse>


                <ProjectBudgetList
                    project_id={props.project_id}
                    budgets={props.budgets}
                    addresses={props.addresses}
                />
            </div>

        )
    }

}

ProjectBudget.propTypes = {
    project_id: PropTypes.string.isRequired,
    addresses: PropTypes.array,
    budgets: PropTypes.array,
}
